<template>
  <RouterLink
    v-if="isAuthenticLink"
    :to="routerLinkTo"
    v-bind="newTabOptions"
    @click.stop
  >
    <slot v-if="$slots.default" />
    <span v-else>{{ path }}</span>
  </RouterLink>
  <Component
    :is="tag"
    v-else
    :href="tag === 'a' ? path : undefined"
    v-bind="newTabOptions"
    @click.stop.prevent="handleClick"
  >
    <slot v-if="$slots.default" />
    <span v-else>{{ path }}</span>
  </Component>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import { mapWaitingActions } from 'vue-wait';
import queryParameter from '@/mixins/query_parameter';

// FIXME: 利用先が自由気ままなのでここもある程度自由度を残しています。最終的に a or something で自動的にrenderされ、固定されるのが美しいと思います
// component構造が見直されたら修正してください
type TTag = 'a' | 'div' | 'span'

export default defineComponent({
  mixins: [queryParameter],
  props: {
    callTargetId: {
      type: Number,
      required: true,
    },
    additionalQueryParams: {
      type: Object as PropType<Record<string, unknown>>,
      required: false,
    },
    tag: {
      type: String as PropType<TTag>,
      required: false,
      default: 'a',
    },
    inNewTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    openByLeadList: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: [
    'beforeMove',
  ],
  computed: {
    isLeadPage(): boolean {
      return this.$route.name === 'LeadList';
    },
    isOpenLeadModal(): boolean {
      return this.isLeadPage;
    },
    isAuthenticLink(): boolean {
      // NOTE: 通常のリンクの挙動をして欲しいケースを明確に別実装としている
      // - リンク（a）でないとき、モーダルを開くとき：独自実装
      // - リンクの挙動のとき：RouterLink
      return this.tag === 'a' && !this.isOpenLeadModal;
    },
    routerLinkTo() {
      return {
        name: 'LeadList',
        query: this.leadListQueryParams,
      };
    },
    newTabOptions() {
      if (!this.inNewTab) return {};
      return {
        target: '_blank',
        rel: 'noopener noreferrer',
      };
    },
    path(): string {
      return this.$router.resolve(this.routerLinkTo).href;
    },
    queryParams(): { callTargetId: number; [key: string]: unknown } {
      return {
        ...this.additionalQueryParams ?? {},
        callTargetId: this.callTargetId,
      };
    },
    leadListQueryParams(): { callTargetId: number; [key: string]: unknown } {
      if (this.isLeadPage) {
        return {
          ...this.getCurrentQueryParameter(),
          ...this.queryParams,
        };
      }
      return { ...this.queryParams };
    },
  },
  methods: {
    ...mapWaitingActions('userUi', {
      setCurrentCallTargetIdAction: 'setCurrentCallTargetIdActionWait',
      setIsLeadOpenByLeadListAction: 'setIsLeadOpenByLeadListActionWait',
    }),
    handleClick(): void {
      this.$emit('beforeMove');
      this.setIsLeadOpenByLeadListAction(this.openByLeadList);

      if (this.isAuthenticLink) return;
      return this.isOpenLeadModal ? this.openLeadModal() : this.moveToLead();
    },
    openLeadModal(): void {
      this.setCurrentCallTargetIdAction(this.callTargetId);
      this.setQueryParameter(this.queryParams);
      this.$modal.show('target');
    },
    moveToLead(): void {
      if (this.inNewTab) {
        window.open(this.$router.resolve(this.routerLinkTo).href, '_blank');
        return;
      }
      this.$router.push(this.routerLinkTo);
    },
  },
});
</script>
